import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { CSS_VARIABLE_REMOVED_SCROLL_BAR } from '../../const/cssVariables';
import { FixedContainer } from '../layout/FixedContainer';
// To prevent jumping after scrollbar remove
const RIGHT = `var(${CSS_VARIABLE_REMOVED_SCROLL_BAR}, 0)`;
export const StickyBottomContainer = ({ children, }) => {
    const layoutWrapperRef = useRef(null);
    const spacerStyle = {
        height: layoutWrapperRef.current?.clientHeight,
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { style: spacerStyle }), _jsx(FixedContainer, { bottom: 0, left: 0, right: RIGHT, children: _jsx("div", { ref: layoutWrapperRef, children: children }) })] }));
};
